// @User Management
// 20-05-2025
import { ADD_USER_ID, REMOVE_USER_ID,  RESET_USER, USER_SELECTED } from "./actionTypes";
const INIT_STATE = {
  selectedUserId: "",
  userIds: [],
};

const UserManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_USER:
      return {
        userIds: [],
        selectedUserId: "",
      };

    case USER_SELECTED:
      return {
        ...state,
        selectedUserId: action.payload,
      };
    case ADD_USER_ID:
      return {
        ...state,
        userIds: action.payload,
      };
    case REMOVE_USER_ID:
      const removeUserId = state.userIds.filter((item) => item !== action.payload);
      return {
        ...state,
        userIds: removeUserId,
      };
      default:
      return state;
  }
};
export default UserManagement;
